var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-bank-details-wrapper":""}},[_c('bank-details-form',{attrs:{"error-in-bank-details":_vm.errorInBankDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }